import {
  pikbaseFaqClasses,
  type ConsentPersistenceAdapter,
  type LegalClasses,
} from "@gsb-core/feature-legal";
import { useFormattingLocale } from "@gsb-core/react-multilang";

export const reviewedLegalLocale = () => useFormattingLocale() ?? "en-US";

export const browserConsentPersistence: ConsentPersistenceAdapter = {
  read(key) {
    try {
      const value = globalThis.localStorage.getItem(key);
      return value ? (JSON.parse(value) as unknown) : undefined;
    } catch {
      return undefined;
    }
  },
  write(key, value) {
    globalThis.localStorage.setItem(key, JSON.stringify(value));
  },
};

export const legalClasses: LegalClasses = {
  ...pikbaseFaqClasses,
  page: "min-h-screen bg-background px-4 py-10 pb-32",
  panel:
    "mx-auto max-w-5xl overflow-hidden rounded-2xl border border-border/70 bg-card shadow-sm",
  markdownHeader: "border-b border-border/70 bg-muted/30 px-6 py-10 sm:px-12",
  eyebrow:
    "mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary",
  title: "text-3xl font-semibold tracking-tight sm:text-5xl",
  subtitle: "mt-4 text-sm text-muted-foreground",
  markdownNav:
    "flex gap-3 border-b border-border/70 px-6 py-4 text-sm sm:px-12",
  markdownLink: "font-medium text-primary underline-offset-4 hover:underline",
  markdownBody:
    "mx-auto max-w-3xl px-6 py-10 text-base leading-8 [&_h2]:mt-14 [&_h2]:border-b [&_h2]:border-border/60 [&_h2]:pb-3 [&_h2]:text-2xl [&_h2]:font-semibold [&_h3]:mt-10 [&_h3]:text-lg [&_h3]:font-semibold [&_p]:my-5 [&_ul]:my-5 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-5 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-2 [&_a]:text-primary [&_a]:underline-offset-4 [&_a:hover]:underline",
  markdownBackToTop:
    "mx-6 mb-8 inline-block text-sm text-muted-foreground sm:mx-12",
  consent:
    "fixed inset-x-0 bottom-0 z-50 border-t border-border/80 bg-background/95 px-4 py-3 shadow-[0_-8px_30px_rgba(0,0,0,0.08)] backdrop-blur sm:px-6",
  consentContent:
    "mx-auto flex max-w-7xl flex-col items-stretch gap-3 sm:flex-row sm:items-center",
  consentCopy: "min-w-0 sm:flex-1",
  consentTitle: "text-sm font-semibold",
  consentDescription: "mt-0.5 text-xs text-muted-foreground",
  consentActions:
    "mx-auto flex max-w-7xl flex-wrap justify-end gap-2 pt-2 sm:pt-0",
  button:
    "rounded-md bg-primary px-3 py-2 text-xs font-semibold text-primary-foreground",
  secondaryButton:
    "rounded-md border border-border bg-background px-3 py-2 text-xs font-medium",
  error: "text-sm text-destructive",
  dialog:
    "fixed inset-0 z-[60] flex items-end justify-center bg-foreground/30 p-4 sm:items-center",
  dialogPanel:
    "w-full max-w-lg rounded-xl border border-border bg-background p-6 shadow-2xl",
};
